import React from "react";

import Button from "../components/Button";

import routes from "../../clhbid-routes";
import { useAuth } from "../concerns/auth/hooks/use-auth";

const RegisterCTA: React.FC = () => {
  const { state } = useAuth();
  const callOut =
    state === "authenticated" ? "Want to Talk Farmland?" : "Ready to Expand?";

  return (
    <div className="mb-16 bg-black">
      <div className="mx-auto px-4 py-6 lg:flex lg:items-center lg:justify-center">
        <h1 className="mb-8 text-center text-3xl font-black text-clhbid-orange lg:mb-0 lg:mr-20 lg:inline-block">
          {callOut}
        </h1>
        {state === "authenticated" && (
          <Button external href="/contact" className="w-full lg:w-auto">
            Contact us
          </Button>
        )}
        {state !== "authenticated" && (
          <Button
            external
            href={routes.register()}
            className="w-full lg:w-auto"
          >
            Create Account
          </Button>
        )}
      </div>
    </div>
  );
};

export default RegisterCTA;
